export enum BonAllotGroupingOrder {
  TOURNEE_PLAT_PLC = 'TOURNEE_PLAT_PLC',
  PLAT_TOURNEE_PLC = 'PLAT_TOURNEE_PLC',
  TOURNEE_PLC_PLAT = 'TOURNEE_PLC_PLAT'
}

export const BON_ALLOT_GROUPING_ORDER_LABELS: Record<BonAllotGroupingOrder, string> = {
  [BonAllotGroupingOrder.TOURNEE_PLAT_PLC]: 'Tournée / Plat / Plc',
  [BonAllotGroupingOrder.PLAT_TOURNEE_PLC]: 'Plat / Tournée / Plc',
  [BonAllotGroupingOrder.TOURNEE_PLC_PLAT]: 'Tournée / Point de livraison / Plat'
};
